var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form',[_c('span',[_vm._v("Pilih Mata Pelajaran ")]),_c('b-form-select',{staticClass:"ml-6",staticStyle:{"width":"50%"},attrs:{"options":_vm.options},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }